import classes from "./SubmitSuccessLink.module.css";
export default function SubmitSuccessLink() {
  let link = localStorage.getItem("gReviewLink");
  let checkString = link.slice(0, 3);
  if (checkString != "htt") link = `https://${link}`;
  console.log(checkString);
  function clickHandler() {
    window.location.href = link;
  }
  return (
    <>
      <div className={classes.container}>
        <div className={classes.content}>
          <p> Kindly review us on Google, it will mean a lot to us.</p>
          <button onClick={clickHandler}>Click</button>
        </div>
      </div>
    </>
  );
}
